import { Box } from '@chakra-ui/react';
import { animate, motion, useMotionValue } from 'framer-motion';

import formatCurrency from 'Helper/formatCurrency';
import formatNumber from 'Helper/formatNumber';
import { Condition } from 'Component/others';
import SkeletonComponent from 'UiKit/skeleton';
import { TextBold, TextRegular } from 'UiKit/typography';

import styles from './styles.module.css';
import { useEffect } from 'react';

const OverviewProgressCard = ({
  title,
  progressCount = 0,
  targetCount = 0,
  isCurrency,
  uom = '',
  uomPosition = 'left',
  isLoading,
  progressPercentage,
  size = 'sm',
}) => {
  const duration = 2;
  const countProgress = useMotionValue(0);
  const leftUom = uomPosition === 'left' ? uom : '';
  const rightUom = uomPosition === 'right' ? uom : '';
  const progressPercentageWidth = progressPercentage > 0 ? `${progressPercentage > 100 ? 100 : progressPercentage}%` : 0;

  const targetCountText = isCurrency ? formatCurrency(targetCount) : `${leftUom} ${formatNumber(targetCount, 1)} ${rightUom}`;
  const progressCountText = isCurrency ? formatCurrency(progressCount) : `${leftUom} ${formatNumber(progressCount, 1)} ${rightUom}`;

  useEffect(() => {
    if (!isLoading) {
      const controls = animate(countProgress, parseInt(progressCount), { duration: duration });
      return () => controls.stop();
    }
  }, [countProgress, duration, progressCount, isLoading]);

  return (
    <Box className={styles['overview-progress__container']}>
      <TextRegular className={`${styles['overview-progress__title']} ${size !== 'sm' ? styles['overview-progress__title-lg'] : ''}`}>{title}</TextRegular>
      <Box className={styles['overview-progress_percentage-container']}>
        <Condition statement={!isLoading} fallback={<SkeletonComponent height="18px" width="100%" />}>
          <Box className={styles['overview-progress__progress-per-target-text']}>
            <TextBold className={`${styles['overview-progress__progress-text']} ${size !== 'sm' ? styles['overview-progress__progress-text-lg'] : ''}`}>
              {progressCountText}
            </TextBold>
            <TextRegular className={styles['overview-progress__target-text--divider']}>/</TextRegular>
            <TextRegular className={styles['overview-progress__target-text']}>{targetCountText}</TextRegular>
          </Box>
        </Condition>
      </Box>

      <Box className={styles['overview-progress__progress-bar-content-container']}>
        <Condition statement={!isLoading}>
          <motion.div className={styles['overview-progress__progress-bar-container']}>
            <motion.div
              animate={{ width: progressPercentageWidth }}
              initial={{ width: 0 }}
              transition={{ duration }}
              className={`${styles['overview-progress__progress-bar-fill-track']} ${
                progressPercentage >= 100 ? styles['overview-progress__progress-bar-fill-track--success'] : ''
              }`}
            />
          </motion.div>
          <motion.pre
            className={`${styles['overview-progress__target-text']} ${
              progressPercentage >= 100 ? styles['overview-progress__target-text--success'] : styles['overview-progress__target-text--warning']
            }`}
          >
            {progressPercentage}%
          </motion.pre>
        </Condition>
      </Box>
    </Box>
  );
};

export default OverviewProgressCard;
